<template>
  <div v-if="!$store.state.infocard.showing">
    <v-container fluid>
      <v-card height="100%" class="mb-10" elevation="1">
        <v-card-title class="ma-1">
          <span
            ><h3 class="font-weight-light">
              {{ $t("users.dash.name") }}
            </h3></span
          >
          <v-spacer></v-spacer>
          <v-tooltip top color="black">
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                fab
                absolute
                right
                x-small
                dark
                elevation="0"
                class="ma-1 mt-2"
                @click="refresh"
              >
                <v-icon size="22">mdi-refresh</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("users.dash.refresh") }}</span>
          </v-tooltip>
          <v-text-field
            class="mt-1 mr-12 ml-6"
            v-model="search"
            append-icon="mdi-magnify"
            :label="$t('users.dash.search')"
            single-line
            rounded
            hide-details
            dense
            filled
          ></v-text-field>
        </v-card-title>
        <v-container fluid>
          <v-data-table
            :headers="headers"
            :items="users"
            :search="search"
            :page.sync="page"
            :items-per-page="itemsPerPage"
            hide-default-footer
            class="dash"
            @page-count="pageCount = $event"
            @click:row="handleClick"
            :loading="$store.state.show.users_loader"
            :loading-text="$t('messanger.dash.loader')"
          >
            <template v-slot:top>
              <v-pagination
                v-show="users.length"
                color="rgb(17, 65, 206)"
                v-model="page"
                :length="pageCount"
                :total-visible="totalVisible"
              ></v-pagination>
            </template>
            <template v-slot:no-data>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ $t("users.dash.no_data") }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <template v-slot:no-results>
              <v-alert
                :value="true"
                outlined
                text
                color="error"
                icon="mdi-alert"
                class="mt-4 text--center"
              >
                {{ `${$t("users.dash.no_result")} '${search}'` }}
              </v-alert>
            </template>
            <template #item.online="{ item }">
              <v-row no-gutters dense justify="start">
                <v-col cols="auto" class="pl-3">
                  <v-icon
                    :color="
                      $store.state.online_users.includes(item.guid.toString())
                        ? 'green'
                        : '#e0e0e0'
                    "
                    size="20"
                    >mdi-record
                  </v-icon>
                </v-col>
              </v-row>
            </template>

            <template #item.firstname="{ item }">
              <span v-if="item.firstname"> {{ item.firstname }}</span>
              <span v-else>-</span>
            </template>
            <template #item.lastname="{ item }">
              <span v-if="item.lastname"> {{ item.lastname }}</span>
              <span v-else>-</span>
            </template>
            <template #item.email="{ item }">
              <span v-if="item.email"> {{ item.email }}</span>
              <span v-else>-</span>
            </template>
            <template #item.username="{ item }">
              <span v-if="item.username"> {{ item.username }}</span>
              <span v-else>-</span>
            </template>
          </v-data-table>
        </v-container>
        <div>
          <v-row class="pt-3 text-center" align="center">
            <v-col cols="12" sm="1" lg="1" class="pb-0 ml-2 pt-1">
              <div :class="$store.state.isMobile ? 'ml-10 mr-10' : ''">
                <v-combobox
                  :value="itemsPerPage"
                  type="number"
                  append-icon=""
                  outlined
                  dense
                  @input="per_elements(itemsPerPage, $event, users)"
                />
              </div>
            </v-col>
            <v-col
              :class="
                $store.state.isMobile
                  ? 'col-md-9 pb-4 pt-0'
                  : 'col-md-10 pb-6 pt-0'
              "
            >
              <v-pagination
                v-show="users.length"
                color="rgb(17, 65, 206)"
                v-model="page"
                :length="pageCount"
                :total-visible="totalVisible"
              ></v-pagination>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      page: 1,
      pageCount: 0,
      itemsPerPage: 30,
      totalVisible: 7,
      search: "",
      headers: [],
    };
  },
  destroyed() {
    this.$store.dispatch("setInfocard", {
      showing: false,
    });
  },
  computed: {
    users: {
      get: function () {
        this.initLabes();
        const user = Object.values(this.$store.state.user.users);
        return user;
      },
    },
  },
  mounted() {
    const user = Object.values(this.$store.state.user.users);
    this.$store.state.show.users_loader = true;
    this.$store
      .dispatch("FETCH_USERS")
      .then((r) => {
        this.$store.state.show.users_loader = false;
      })
      .catch((err) => {
        this.$store.state.show.users_loader = false;
      });
  },
  methods: {
    initLabes() {
      this.headers = [
        {
          text: this.getlable("online"),
          value: "online",
          sortable: false,
        },
        {
          text: "Id",
          align: "start",
          sortable: true,
          value: "id",
        },
        {
          text: this.getlable("firstname"),
          value: "firstname",
          sortable: true,
        },
        {
          text: this.getlable("lastname"),
          value: "lastname",
          sortable: true,
        },
        {
          text: this.getlable("email"),
          value: "email",
          sortable: true,
        },
        {
          text: this.getlable("username"),
          value: "username",
          sortable: true,
        },
        {
          text: this.getlable("created_at"),
          value: "created_at",
        },
      ];
    },
    getlable(name) {
      return this.$t(`users.dash.table_head.${name}`);
    },
    refresh() {
      this.$store.state.show.users_loader = true;
      this.$store.dispatch("FETCH_USERS").then((r) => {
        this.$store.state.show.users_loader = false;
      });
    },
    handleClick(item) {
      this.$store.dispatch("setCloader", { showing: true });
      this.$store.dispatch("FETCH_USER", item.id).then((response) => {
        this.$store.dispatch("setInfocard", {
          showing: true,
          id: item.id,
          user: item,
        });
        this.$store.dispatch("setCloader", { showing: false });
        this.$store.state.display_grid = {
          liked: 4,
          disliked: 4,
          seen: 4,
          outher: 4,
          bookmarked: 4,
          recommended_IA: 4,
        };
      });
    },
    per_elements(itemsPerPage, event, user) {
      if (event > 0) this.itemsPerPage = parseInt(event, 10);
      else {
        this.$store.dispatch("setSnackbar", {
          text: `The minimum users perpage to display is 1`,
          color: "warning",
          timeout: 1000,
        });
      }
    },
  },
};
</script>

<style>
.dash {
  background: white;
  border-bottom: solid 1px #d4d2d2;
  border: 1px solid #d4d2d2;
}

.dash .v-data-table thead th span {
  margin-right: 8px;
}

.dash .v-data-table thead th {
  font-size: 14px;
}

.dash .v-data-table tbody tr {
  cursor: pointer;
}
</style>
